import React from 'react'
import { Link } from 'react-router-dom'
import Icon from '../../../components/Icon'
import {
  getDepartmentInitials,
  getDepartmentLeadName,
  pluralizeRu,
} from './departmentListUtils'

function DepartmentCardLink({
  department,
  group,
  canReorder,
  onDragStart,
  onDragOver,
  onDrop,
}) {
  const employeesCount = Number(department?.employees_count || 0)
  const teamsCount = Number(department?.teams_count || 0)
  const dataType = group === 'production' ? 'production' : 'support'

  return (
    <div
      className="dept-card-shell"
      data-reorder={canReorder ? 'true' : undefined}
      onDragOver={canReorder ? onDragOver : undefined}
      onDrop={canReorder ? (event) => onDrop(event, department, group) : undefined}
    >
      <Link
        to={`/company/departments/${department.id}`}
        className="dept-card"
        data-type={dataType}
      >
        <div className="dept-card-head">
          <div className="dept-icon">{getDepartmentInitials(department.name)}</div>
          <div className="dept-card-title-block">
            <div className="dept-card-name">{department.name}</div>
            <div className="dept-card-lead">{getDepartmentLeadName(department)}</div>
          </div>
        </div>
        <div className="dept-card-stats">
          <div className="dept-stat">
            <span className="dept-stat-value">{employeesCount}</span>
            <span className="dept-stat-label">
              {pluralizeRu(employeesCount, 'сотрудник', 'сотрудника', 'сотрудников')}
            </span>
          </div>
          <div className="dept-stat">
            <span className="dept-stat-value">{teamsCount}</span>
            <span className="dept-stat-label">
              {pluralizeRu(teamsCount, 'команда', 'команды', 'команд')}
            </span>
          </div>
        </div>
        <div className="dept-card-foot">Открыть →</div>
      </Link>

      {canReorder && (
        <span
          className="dept-card-drag-cue"
          title="Перетащите для изменения порядка"
          aria-label={`Перетащить подразделение ${department.name}`}
          draggable
          onDragStart={(event) => onDragStart(event, department, group)}
        >
          <Icon name="menu" size={16} />
        </span>
      )}
    </div>
  )
}

export default DepartmentCardLink
